import { InjectionToken } from '@angular/core';

/**
 * Token for configuring the search debounce time in milliseconds
 */
export const LIST_QUERY_DEBOUNCE_TIME = new InjectionToken<number>('SEARCH_DEBOUNCE_TIME', {
  providedIn: 'root',
  factory: () => 1000, // Default value is 1000ms
});
